var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("修理お申し込み")]), _c('v-card', [_c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formValid),
      callback: function($$v) {
        _vm.formValid = $$v
      },
      expression: "formValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "row"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "xs8",
      "sm9": "sm9",
      "md10": "md10",
      "lg11": "lg11"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "郵便番号",
      "required": "required",
      "rules": _vm.zipCodeRules
    },
    model: {
      value: (_vm.zipCode),
      callback: function($$v) {
        _vm.zipCode = $$v
      },
      expression: "zipCode"
    }
  })], 1), _c('v-flex', {
    attrs: {
      "xs4": "xs4",
      "sm3": "sm3",
      "md2": "md2",
      "lg1": "lg1"
    }
  }, [_c('v-btn', {
    attrs: {
      "light": "light",
      "disabled": _vm.zipCode === null || _vm.zipCode.length === 0
    },
    on: {
      "click": _vm.searchAddress
    }
  }, [_vm._v("住所検索")])], 1)], 1), _c('v-text-field', {
    attrs: {
      "label": "住所1",
      "required": "required",
      "rules": _vm.address1Rules,
      "counter": _vm.addressMaxLength
    },
    model: {
      value: (_vm.address1),
      callback: function($$v) {
        _vm.address1 = $$v
      },
      expression: "address1"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "住所2 (番地・建物名・号室)",
      "rules": _vm.address2Rules,
      "counter": _vm.addressMaxLength
    },
    model: {
      value: (_vm.address2),
      callback: function($$v) {
        _vm.address2 = $$v
      },
      expression: "address2"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "氏名",
      "required": "required",
      "rules": _vm.nameRules,
      "counter": _vm.nameMaxLength
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "電話番号",
      "required": "required",
      "rules": _vm.telRules
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "製品型番",
      "required": "required",
      "rules": _vm.productIdRules,
      "counter": _vm.productIdMaxLength
    },
    model: {
      value: (_vm.productId),
      callback: function($$v) {
        _vm.productId = $$v
      },
      expression: "productId"
    }
  }), _c('v-text-field', {
    attrs: {
      "label": "故障内容など",
      "multi-line": "multi-line",
      "required": "required",
      "rules": _vm.descriptionRules,
      "counter": _vm.descriptionMaxLength
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _c('v-btn', {
    attrs: {
      "primary": "primary",
      "dark": "dark"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("送信")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "lazy": "lazy",
      "persistent": "persistent"
    },
    model: {
      value: (_vm.visibleCompletionDialog),
      callback: function($$v) {
        _vm.visibleCompletionDialog = $$v
      },
      expression: "visibleCompletionDialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("修理のお申込みを受け付けました。")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "indigo--text darken-2",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("OK")]), _c('v-spacer')], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d44d27a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Repair.vue
// module id = b/Hb
// module chunks = 1